module.exports = __webpack_public_path__ + "assets/716018ec2fa7fad3d0373bd783fe87a8.mp4";